module.exports = __webpack_public_path__ + "img/key_hover.30df3073.png";